import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const failures = [{
    title: 'YouTube tutorials dispersos',
    desc: 'Edits bonitos, cero clientes. No hay workflows para mamás.',
    delay: 0
  }, {
    title: 'Fiverr genérico',
    desc: 'Precios de $5 con competencia mundial. No hay nicho latino.',
    delay: 0.1
  }, {
    title: 'Aprendo sola',
    desc: 'Abrumada, sin mensajes probados. Falta el mapa hacia el $$.',
    delay: 0.2
  }];
  return <section className="py-20 bg-white relative overflow-hidden" data-id="element-11">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#2D1B0E 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-12"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-13">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2D1B0E] mb-4" data-id="element-15">
            ❌ Lo Que Ya Intentaste{' '}
            <span className="text-[#E8614D]" data-id="element-16">(Y No Funcionó)</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-17">
          {failures.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: item.delay
        }} className="relative bg-gray-50 p-8 rounded-2xl border border-gray-200 group hover:bg-red-50 transition-colors duration-300" data-id="element-18">
              {/* Big X background */}
              <div className="absolute top-4 right-4 text-red-200 opacity-50 group-hover:opacity-100 transition-opacity" data-id="element-19">
                <X className="w-12 h-12" data-id="element-20" />
              </div>

              <h3 className="text-xl font-bold text-[#2D1B0E] mb-3 line-through decoration-red-500 decoration-2 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-21">
                {item.title}
              </h3>
              <p className="text-[#2D1B0E]/70 leading-relaxed" data-id="element-22">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}